import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@shared/components/icon';
import { TooltipDirective } from '@shared/directives/tooltip';

/**
 * Pastille d'aide a poser dans un en-tete de colonne d'`app-table`.
 *
 * A remplace la propriete `headerInfo` que les listes declaraient : elle
 * n'existe PAS dans `TableColumn` et n'etait donc jamais rendue. Le type ne
 * l'avait pas signale — `TableColumn<T>` etant une intersection avec une grande
 * union, le controle des proprietes excedentaires ne s'y applique pas (verifie :
 * une propriete totalement inventee compile sans erreur). Les quatre infobulles
 * declarees etaient donc silencieusement perdues.
 *
 * Passe par `headerTemplate`, le point d'accroche prevu par le kit.
 *
 * ## Le nom accessible est porte ICI, pas par la directive
 *
 * `tooltip.directive.ts` ne contient AUCUN attribut `aria` (0 occurrence) : elle
 * pose bien `role="tooltip"` sur le panneau, mais rien ne relie le declencheur au
 * panneau — pas d'`aria-describedby`. Sans `aria-label`, le `tabindex="0"` faisait
 * donc s'arreter le focus clavier sur un element sans role ni nom, et le texte de
 * l'infobulle — la seule information portee par la pastille, et du contenu METIER
 * (« Montant total reverse au client + commissions ») — n'etait jamais annonce.
 *
 * Le manque d'`aria-describedby` appartient a V3 et se remonte la-bas : le corriger
 * dans la directive serait une 8e divergence du kit. On nomme donc le declencheur
 * cote consommateur.
 */
@Component({
  selector: 'app-entete-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective],
  template: `
    <span
      class="ml-1 inline-flex align-middle text-content-tertiary"
      [appTooltip]="info()"
      [attr.aria-label]="info()"
      role="note"
      tabindex="0"
    >
      <app-icon name="info" size="xs" />
    </span>
  `,
})
export class EnteteInfoComponent {
  readonly info = input.required<string>();
}
